const DEFAULT_TIMEOUT_MS = 5000;
const POLL_INTERVAL_MS = 100;

export const parseTourRoute = (
  route: string,
): { pathname: string; search: string } => {
  const [pathname, query = ''] = route.split('?');
  return {
    pathname,
    search: query ? `?${query}` : '',
  };
};

export const matchesTourRoute = (route: string): boolean => {
  const { pathname, search } = parseTourRoute(route);
  if (window.location.pathname !== pathname) return false;
  if (!search) return true;
  return window.location.search === search;
};

export const waitForTourRoute = (
  route: string,
  timeoutMs = DEFAULT_TIMEOUT_MS,
): Promise<void> =>
  new Promise(resolve => {
    if (matchesTourRoute(route)) {
      resolve();
      return;
    }

    const startedAt = Date.now();

    const intervalId = window.setInterval(() => {
      if (matchesTourRoute(route)) {
        window.clearInterval(intervalId);
        resolve();
        return;
      }

      if (Date.now() - startedAt >= timeoutMs) {
        window.clearInterval(intervalId);
        resolve();
      }
    }, POLL_INTERVAL_MS);
  });

/** @deprecated Use waitForTourRoute — supports query strings e.g. /content?tab=value-content */
export const waitForPathname = waitForTourRoute;

export const waitForElement = (
  selector: string,
  timeoutMs = DEFAULT_TIMEOUT_MS,
): Promise<HTMLElement | null> =>
  new Promise(resolve => {
    const existing = document.querySelector(selector) as HTMLElement | null;
    if (existing) {
      resolve(existing);
      return;
    }

    const startedAt = Date.now();

    const intervalId = window.setInterval(() => {
      const element = document.querySelector(selector) as HTMLElement | null;
      if (element) {
        window.clearInterval(intervalId);
        resolve(element);
        return;
      }

      if (Date.now() - startedAt >= timeoutMs) {
        window.clearInterval(intervalId);
        resolve(null);
      }
    }, POLL_INTERVAL_MS);
  });

export const expandAccordionTarget = (element: HTMLElement): void => {
  const summary =
    element.classList.contains('MuiAccordionSummary-root')
      ? element
      : (element.closest('.MuiAccordionSummary-root') as HTMLElement | null);

  if (summary && summary.getAttribute('aria-expanded') === 'false') {
    summary.click();
  }
};

export const scrollTargetIntoView = (element: HTMLElement): void => {
  element.scrollIntoView({ behavior: 'smooth', block: 'center' });
};

export const getTargetRect = (element: HTMLElement, padding = 8): DOMRect => {
  const rect = element.getBoundingClientRect();
  return new DOMRect(
    rect.left - padding,
    rect.top - padding,
    rect.width + padding * 2,
    rect.height + padding * 2,
  );
};
